import { defineComponent as _defineComponent } from 'vue'
import { useGlobalBi } from '@/hooks/use-global-bi';
import { useMerchantInfo } from '@/store/merchant-info-module';
import Banner from '@tencent/wphk-components-banner';
import { toRefs } from 'vue';
import { filterBannerBySpid } from './business/index';
import { BANNER_DP_POSITION } from '@/config/banner-dp-config';
import { DP_PAGE } from '@/config/dp-config';
import { BusinessBannerConfig } from './business/type';
import { mittBus, MITT_TYPES } from '@/business/mitt-bus';
import { biClick } from '@tencent/fit-bi-sdk';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { merchantConfig } = toRefs(useMerchantInfo());
const { getBiExt } = useGlobalBi();

function bannerClick(item) {
  if (item?.originalData?.customEventKey === 'shareCoupon') {
    mittBus.emit(MITT_TYPES.bannerShareCouponClick);
    biClick('banner.shareCoupon_click', getBiExt());
  }
}

function transformer(list: BusinessBannerConfig[]) {
  /**
   * 1. 根据 spid 过滤 banner
   * 2. 修改 banner 的 bannerTag 为跳转信息（format前都是同一个spId），便于埋点的区分
   */
  const data = filterBannerBySpid(list, merchantConfig.value.spId)
    .map((ele) => {
      let tag = '';
      if (ele.bannerJumpInfo) {
        // @ts-ignore
        const { jumpUrl, miniAppId, miniAppUsername } = ele.bannerJumpInfo;
        tag = jumpUrl || miniAppId || miniAppUsername;
      }
      return { ...ele, bannerTag: tag };
    });
  return data;
}


return { __sfc: true,merchantConfig, getBiExt, bannerClick, transformer, Banner, BANNER_DP_POSITION, DP_PAGE }
}

})